import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateUtilsService, TranslationService } from '@sdbn/common';
import { TransportOptionLimitExceptionSchedule } from '../../../transport-options.model';

@Component({
    selector: 'app-transport-option-editor-limits-exception-schedule',
    templateUrl: './transport-option-editor-limits-exception-schedule.component.html',
    styleUrls: ['./transport-option-editor-limits-exception-schedule.component.scss'],
    standalone: false
})
export class TransportOptionEditorLimitsExceptionScheduleComponent implements OnInit {

  formGroup = new FormGroup({
    dateFrom: new FormControl(),
    dateUntil: new FormControl(),
    limitMonday: new FormControl(),
    limitTuesday: new FormControl(),
    limitWednesday: new FormControl(),
    limitThursday: new FormControl(),
    limitFriday: new FormControl(),
    limitSaturday: new FormControl(),
    limitSunday: new FormControl()
  });

  @Input() exceptionSchedule?: TransportOptionLimitExceptionSchedule;

  @Output() removeRequested = new EventEmitter<TransportOptionLimitExceptionSchedule>();

  @Output() changed = new EventEmitter<TransportOptionLimitExceptionSchedule>();

  constructor(
    public translationService: TranslationService,
    private dateUtilsService: DateUtilsService
  ) {

  }

  ngOnInit(): void {
    this.initialize();
    this.formGroup.valueChanges.subscribe(value => {
      if (this.exceptionSchedule) {
        this.exceptionSchedule.dateFrom = this.dateUtilsService.convertDateToDatePartTimestamp(value.dateFrom);
        this.exceptionSchedule.dateUntil = this.dateUtilsService.convertDateToDatePartTimestamp(value.dateUntil);
        this.exceptionSchedule.limitMonday = this.formGroup.get('limitMonday')?.value;
        this.exceptionSchedule.limitTuesday = this.formGroup.get('limitTuesday')?.value;
        this.exceptionSchedule.limitWednesday = this.formGroup.get('limitWednesday')?.value;
        this.exceptionSchedule.limitThursday = this.formGroup.get('limitThursday')?.value;
        this.exceptionSchedule.limitFriday = this.formGroup.get('limitFriday')?.value;
        this.exceptionSchedule.limitSaturday = this.formGroup.get('limitSaturday')?.value;
        this.exceptionSchedule.limitSunday = this.formGroup.get('limitSunday')?.value;
        this.changed.emit(this.exceptionSchedule);
      }
    });
  }

  private initialize() {
    if (this.exceptionSchedule) {
      this.formGroup.patchValue({
        dateFrom: this.dateUtilsService.parseDateFromDatePartTimestamp(this.exceptionSchedule.dateFrom!),
        dateUntil: this.dateUtilsService.parseDateFromDatePartTimestamp(this.exceptionSchedule.dateUntil!),
        limitMonday: this.exceptionSchedule.limitMonday,
        limitTuesday: this.exceptionSchedule.limitTuesday,
        limitWednesday: this.exceptionSchedule.limitWednesday,
        limitThursday: this.exceptionSchedule.limitThursday,
        limitFriday: this.exceptionSchedule.limitFriday,
        limitSaturday: this.exceptionSchedule.limitSaturday,
        limitSunday: this.exceptionSchedule.limitSunday
      });
    }
  }

  public removeLimitExceptionSchedule(): void {
    if (this.exceptionSchedule) {
      this.removeRequested.emit(this.exceptionSchedule);
    }
  }

}
